import { instance, errorService } from '@/services/api'
import { dropdownAPIs, settingAPIs } from '@/services/authConstantsV1'
import { showNotification, calculateHeight } from '@/services/calculate'
import _ from 'lodash'
import {
  dateTimeFormats,
  dateFormats,
  timeFormats,
  currencyFormats,
} from './data.json'
import moment from 'moment'
import { templateColumns, projectColumns } from '@/services/config'

export default {
  components: {},
  data: function() {
    const checkRecords = (rule, value, callback) => {
      if (rule.field === 'application.deletedProjectValidity') {
        if (value < 1) {
          callback(
            new Error(
              'Deleted project validity must be greater than or equals to 1',
            ),
          )
        } else {
          callback()
        }
      } else {
        if (value < 50) {
          callback(
            new Error('Default records must be greater than or equals to 50'),
          )
        } else {
          callback()
        }
      }
    }
    return {
      timeZoneList: [],
      currencyList: [],
      dateTimeFormatList: dateTimeFormats,
      dateFormatList: dateFormats,
      timeFormatList: timeFormats,
      currencyFormatList: currencyFormats,
      loading: true,
      templateSelectAll: false,
      projectSelectAll: false,
      email: undefined,
      headStyle: {
        fontWeight: 'bold',
        background: '#333333 !important',
        color: '#ffffff !important',
        padding: '0 10px',
      },
      form: {
        datetime: {
          dateFormat: undefined,
          dateTimeFormat: undefined,
          timeZoneId: undefined,
          timeZone: undefined,
          timeZoneValue: undefined,
          timeFormat: undefined,
        },
        currency: {
          currencyId: undefined,
          currency: undefined,
          currencyFormate: undefined,
          currencyValue: undefined,
        },
        application: {
          defaultRecord: 0,
          deletedProjectValidity: 0,
          oktaApiToken: undefined,
          email: undefined,
          allowedTemplateDelete: false,
        },
        column: {
          templateColumnsDetails: templateColumns,
          projectColumnsDetails: projectColumns,
        },
        email: {
          emailIds: [],
        },
        id: null,
      },
      rules: {
        datetime: {
          dateTimeFormat: [
            {
              required: true,
              message: 'Please select date time format',
              trigger: 'change',
            },
          ],
          dateFormat: [
            {
              required: true,
              message: 'Please select date format',
              trigger: 'change',
            },
          ],
          timeFormat: [
            {
              required: true,
              message: 'Please select time format',
              trigger: 'change',
            },
          ],
        },
        currency: {
          currencyId: [
            {
              required: true,
              message: 'Please select currency',
              trigger: 'change',
            },
          ],
          currencyFormate: [
            {
              required: true,
              message: 'Please select currency format',
              trigger: 'change',
            },
          ],
        },
        application: {
          defaultRecord: [
            {
              required: true,
              message: 'Please enter default records',
              trigger: ['change', 'blur'],
            },
            { validator: checkRecords, trigger: 'blur' },
          ],
          deletedProjectValidity: [
            {
              required: true,
              message: 'Please enter deleted project validity',
              trigger: ['change', 'blur'],
            },
            { validator: checkRecords, trigger: 'blur' },
          ],
          oktaApiToken: [
            {
              required: true,
              message: 'Please enter okta API token',
              trigger: 'blur',
            },
          ],
        },
      },
      height: '100%',
    }
  },
  created() {
    this.dateTimeFormatList.sort((a, b) =>
      a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
    )
    this.dateFormatList.sort((a, b) =>
      a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
    )
    this.timeFormatList.sort((a, b) =>
      a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
    )
    this.currencyFormatList.sort((a, b) =>
      a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
    )
    this.getDropdowns()
    this.getSettings()
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    isNumber(evt) {
      evt = !evt ? window.event : evt
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      }
    },

    // Get Dropdowns
    getDropdowns() {
      instance
        .post(dropdownAPIs.dropdown, {
          time_zone: 0,
          currency: 0,
        })
        .then(response => {
          this.timeZoneList = _.get(response.data, 'result.time_zone', [])
          this.currencyList = _.get(response.data, 'result.currency', [])
          const timezone = this.timeZoneList.find(
            i => i.value === moment.tz.guess(),
          )
          if (timezone) {
            this.form.datetime.timeZone = `${moment.tz.guess()} - ${
              timezone.option
            }`
            this.form.datetime.timeZoneId = timezone.id
            this.form.datetime.timeZoneValue = moment.tz.guess()
          }
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Get Application Settings
    getSettings() {
      instance
        .get(settingAPIs.getSetting)
        .then(response => {
          this.loading = false
          this.setSettings(response.data)
          this.height = calculateHeight(
            'usersettings',
            false,
            false,
            false,
            false,
            true,
          )
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Update Application Settings
    updateSettings() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const emailIds = this.form.email.emailIds
          if (emailIds.length === 0) {
            showNotification(
              'error',
              'Email Settings',
              'Please enter atleast one email id!',
            )
            return
          }
          this.loading = true
          instance
            .put(settingAPIs.updateSetting, {
              id: this.form.id,
              datetime: {
                timeZoneId: this.form.datetime.timeZoneId,
                dateTimeFormat: this.form.datetime.dateTimeFormat,
                dateFormat: this.form.datetime.dateFormat,
                timeFormat: this.form.datetime.timeFormat,
              },
              currency: {
                currencyId: this.form.currency.currencyId,
                currencyFormate: this.form.currency.currencyFormate,
              },
              application: {
                defaultRecord: this.form.application.defaultRecord,
                deletedProjectValidity: this.form.application
                  .deletedProjectValidity,
                oktaApiToken: this.form.application.oktaApiToken,
                email: emailIds.join(', '),
                allowedTemplateDelete: this.form.application.allowedTemplateDelete,
              },
              column: {
                projectColumnDetails: JSON.stringify(
                  this.form.column.projectColumnsDetails,
                ),
                templateColumnDetails: JSON.stringify(
                  this.form.column.templateColumnsDetails,
                ),
              },
            })
            .then(response => {
              showNotification(
                'success',
                'Update Settings',
                'Application settings has been updated successfully!',
              )
              this.loading = false
              this.email = undefined
              if (emailIds.length > 0) {
                this.form.application.email = emailIds.join(', ')
              }
              localStorage.removeItem('userSettings')
              localStorage.setItem('userSettings', JSON.stringify(this.form))
            })
            .catch(error => {
              this.loading = false
              errorService(error)
            })
        }
      })
    },

    // Dropdown Methods
    changeCurrency(value) {
      const currency = this.currencyList.find(i => i.id === value)
      this.form.currency.currencyValue = currency.value
      this.form.currency.currency = currency.option
    },

    // Format Dates
    formatDate(format) {
      return moment(new Date()).format(format)
    },

    // Format Currency
    formatCurrency() {
      if (this.form.currency.currencyFormate && this.form.currency.currency) {
        return new Intl.NumberFormat(this.form.currency.currencyFormate, {
          style: 'currency',
          currency: this.form.currency.currency,
        }).format('1234567890.789')
      }
    },

    onChange(e, index, type) {
      if (type === 'Template') {
        this.form.column.templateColumnsDetails[index].hide = !e.target.checked
      } else {
        this.form.column.projectColumnsDetails[index].hide = !e.target.checked
      }
      this.checkAll()
    },

    setSettings(setting) {
      this.form.id = _.get(setting, 'result.id', null)
      this.form.datetime = _.get(setting, 'result.datetime', null)
      this.form.currency = _.get(setting, 'result.currency', null)
      this.form.application = _.get(setting, 'result.application', null)
      const element = {
        header: 'Group Quantity',
        colId: 'groupQuantity',
        width: 100,
        hide: false,
        pinned: null,
        sort: null,
        sortIndex: null,
        aggFunc: null,
        rowGroup: false,
        rowGroupIndex: null,
        pivot: false,
        pivotIndex: null,
        flex: null,
        display: true,
      }
      if (_.get(setting, 'result.column.templateColumnDetails', undefined)) {
        this.form.column.templateColumnsDetails = JSON.parse(
          setting.result.column.templateColumnDetails,
        )
        const isPresent = this.form.column.templateColumnsDetails.find(
          i => i.colId === 'groupQuantity',
        )
        if (!isPresent) {
          const index = this.form.column.templateColumnsDetails.findIndex(
            i => i.colId === 'quantity',
          )
          this.form.column.templateColumnsDetails.splice(index, 0, element)
        }
      }
      if (_.get(setting, 'result.column.projectColumnDetails', undefined)) {
        this.form.column.projectColumnsDetails = JSON.parse(
          setting.result.column.projectColumnDetails,
        )
        const isPresent = this.form.column.projectColumnsDetails.find(
          i => i.colId === 'groupQuantity',
        )
        if (!isPresent) {
          const index = this.form.column.projectColumnsDetails.findIndex(
            i => i.colId === 'quantity',
          )
          this.form.column.projectColumnsDetails.splice(index, 0, element)
        }
      }
      if (_.get(setting, 'result.application.email', undefined)) {
        this.form.email.emailIds = setting.result.application.email.split(', ')
      }
      this.checkAll()
    },

    onSelectAll(e, type) {
      if (type === 'Template') {
        this.templateSelectAll = e.target.checked
        this.form.column.templateColumnsDetails.forEach(element => {
          element.hide = !e.target.checked
        })
      } else {
        this.projectSelectAll = e.target.checked
        this.form.column.projectColumnsDetails.forEach(element => {
          element.hide = !e.target.checked
        })
      }
    },

    checkAll() {
      const templateCount = this.form.column.templateColumnsDetails.filter(
        i => i.hide,
      )
      this.templateSelectAll = !(templateCount.length > 0)
      const projectCount = this.form.column.projectColumnsDetails.filter(
        i => i.hide,
      )
      this.projectSelectAll = !(projectCount.length > 0)
    },

    onResize() {
      this.height = calculateHeight(
        'usersettings',
        false,
        false,
        false,
        false,
        true,
      )
    },

    addEmailIds($event) {
      if ($event.target.value && $event.target.value.trim()) {
        const regex = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/
        if (regex.test($event.target.value)) {
          const present = this.form.email.emailIds.find(
            i => i.toLowerCase() === $event.target.value.toLowerCase(),
          )
          if (!present) {
            this.form.email.emailIds.push($event.target.value)
          }
          this.email = undefined
        } else {
          showNotification(
            'error',
            'Email Settings',
            'Please enter valid email id!',
          )
        }
      } else {
        this.email = undefined
      }
    },

    removeEmailIds(index) {
      this.form.email.emailIds.splice(index, 1)
    },
  },
}
